module.exports = __webpack_public_path__ + "static/media/send-white.0ee60556.svg";